import { render, staticRenderFns } from "./ExpenseCategoryWidgetRow.vue?vue&type=template&id=0c127f3f&scoped=true"
import script from "./ExpenseCategoryWidgetRow.vue?vue&type=script&lang=ts"
export * from "./ExpenseCategoryWidgetRow.vue?vue&type=script&lang=ts"
import style0 from "./ExpenseCategoryWidgetRow.vue?vue&type=style&index=0&id=0c127f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c127f3f",
  null
  
)

export default component.exports